module.exports = __webpack_public_path__ + "be24546b218fb115fe5d96c73ccce9f0.png";